import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { ApiResponse, RecognizeResponse } from '../../../types/api';

export const queryKey = 'spoofing';

interface SpoofingResponse {
	is_spoofing: boolean;
	is_demoing: boolean;
}

export const useSpoofing = (options: UseQueryOptions<ApiResponse<SpoofingResponse>, unknown, SpoofingResponse> = {}) => {
	const http = useHttpClient();

	return useQuery<ApiResponse<SpoofingResponse>, unknown, SpoofingResponse>(
		[queryKey],
		() => {
			return http.get<RecognizeResponse<SpoofingResponse>>('/spoofing');
		},
		{
			refetchInterval: Infinity,
			select: (data) => data.data.result,
			...options,
		}
	);
};
